<template>

  <v-main>

    <v-container
        id="about-us-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-information-outline"
          class="px-5 py-3"
      >


        <v-card-text>

          <v-row>
            <v-col
                cols="12"
                sm="12"
            >
              <h3>About Tilyet Benevolence Fund</h3>

              <p>
                Tilyet Benevolence Fund is a Minnesota nonprofit corporation (EIN: 82-5259148) founded in 2016. Rooted in the Kalenjin community of Minnesota, our mission is to provide social, emotional, and financial support to our members in times of bereavement —
                and to help them travel to Kenya or other lands to be with family during those difficult moments.
                We are a member-driven organization built on mutual aid and community trust. When a member or one of their loved ones passes away, Tilyet steps in with meaningful financial assistance so that families can focus on what matters most: grieving, healing, and being together.
              </p>

              <h4>How the Fund Works</h4>
              <p>
                Tilyet operates as a pooled benevolence fund, sustained entirely by member contributions and managed by an elected Board of Directors. Funding comes from three sources: a one-time registration fee paid upon joining, bi-annual dues of $50 due each April and October,
                and prorated replenishment payments made by all members following each bereavement disbursement.
                When a loss occurs — whether the member themselves, a spouse, child, parent, or biological sibling — the affected member or their representative submits a Bereavement Assistance Request. The Oversight Committee verifies the claim, and upon approval by the President, funds are disbursed.
              </p>

              <p>Current bereavement assistance amounts are:</p>
              <ul>
                <li>$9,000 for the loss of a biological sibling or parent</li>
                <li>$7,000 for the loss of a member, spouse, or biological/adopted child</li>
                <li>$7,000 for a covered stillbirth, as recognized under Minnesota law</li>
              </ul>

              <p>
                Each member contributes $25 per occurrence to replenish the fund after a disbursement, ensuring it remains ready to support the next family in need.
                There is a yearly cap of $32,000 or 5 occurrences per member, and a minimum fund balance is always maintained to guarantee disbursements can be made even during difficult periods.
              </p>

              <h4>Membership Eligibility</h4>
              <p>
                To join Tilyet Benevolence Fund, an applicant must meet at least one of the following requirements:</p>

                <ul>
                  <li>Be a Kalenjin resident in Minnesota (note: members enrolled as of January 1, 2018 who have since moved out of Minnesota may continue their membership)</li>
                  <li>Be a spouse of a Kalenjin resident in Minnesota</li>
                  <li>Be a non-Kalenjin resident in Minnesota, nominated by at least 3 existing members and approved unanimously by the Board</li>
                </ul>

              <p>
                Tilyet welcomes families and individuals who share our commitment to community and mutual support. The Board reserves the right to reject any applicant whose conduct is deemed inconsistent with the values and mission of the organization,
                including behavior that is disrespectful, unethical, or contrary to Tilyet's vision.
                Once accepted, a member's covered beneficiaries include:
              </p>

              <ul>
                <li>The member themselves</li>
                <li>Their spouse</li>
                <li>Biological or legally adopted children (including all live births and covered stillbirths)</li>
                <li>Biological or adopting parents</li>
                <li>Biological siblings (step and half siblings are not covered)</li>
              </ul>

              <h4>Enrollment</h4>
              <p>
                New members are welcomed during the annual Open Enrollment Period of April 1 to April 30 each year. Exceptions to the enrollment window are made for individuals newly arriving in Minnesota from abroad or from another U.S. state, as well as newly married spouses.
                A 90-day grace period applies to all new members before they become eligible to receive assistance.
              </p>

              <h4>Membership Fees</h4>
                <p>
                Membership fees consist of a one-time non-refundable registration fee and ongoing bi-annual dues:
                </p>
                <p><em>One-Time Registration Fee:</em></p>

                <ul>
                  <li>$250 — New students, eligible to join anytime within their first year of arrival in Minnesota</li>
                  <li>$500 — New adult arrivals to Minnesota, with a one-year grace period from date of arrival to join</li>
                  <li>$500 — Legacy Minnesota residents (living in Minnesota for over a year), eligible to join during open enrollment only</li>
                </ul>

                <p><em>Ongoing Dues:</em></p>
                <ul>
                  <li>$50 due on April 30th each year</li>
                  <li>$50 due on October 31st each year</li>
                  <li>$25 per occurrence replenishment, paid within 30 days of each bereavement disbursement</li>
                </ul>

                <p>
                  All dues and registration fees are non-refundable. Members who fall behind on payments are subject to suspension and potential removal from the fund.
                </p>
                <p>
                  Governed by an elected Board of Directors and an independent Oversight Committee, Tilyet operates with transparency, accountability, and a deep commitment to the well-being of every member.
                  We are guided by the principle that no one in our community should face loss alone.
                </p>


              <h4>Legal & IRS Registration</h4>
              <p>Tilyet Benevolence Fund is a legally registered nonprofit organization in the state of Minnesota and with the Internal Revenue Service (IRS):</p>

              <ul>
                <li>Organization Type: Minnesota Nonprofit Corporation</li>
                <li>Employer Identification Number (EIN): 82-5259148</li>
                <li>Governing Law: Minnesota Nonprofit Corporations Act, Chapter 317A</li>
                <li>Bylaws Adopted: March 25, 2024</li>
                <li>Fiscal Year: January 1 – December 31</li>
              </ul>

              <p>As a registered nonprofit, Tilyet operates under the governance of an elected Board of Directors and an independent Oversight Committee, ensuring financial accountability and ethical management of the fund.
              All financial records, meeting minutes, and organizational documents are maintained in accordance with Minnesota state law and IRS requirements.
              </p>

            <p><em>Contributing to the well-being of our members during life's most distressful times.</em></p>


            </v-col>
          </v-row>

        </v-card-text>

      </base-material-card>

    </v-container>
  </v-main>

</template>

<script>


export default {
  name: "CoreAboutUsView",
  created() {
  },
  components: {
  },
  methods: {},
  data() {
    return {
    }
  }
};

</script>

<style lang="scss" scoped>
  ul {
    list-style-type: disc;
    padding-bottom: 0.5em;
  }

  h3 {
    padding-bottom: .75em;
  }

  h4 {
    padding-top: .5em;
    padding-bottom: .5em;
  }
</style>
